import { useDispatch } from "react-redux"
import { IOrderItems } from "../../interface/IOrderItem"
import { setDeleteItemsStore } from "../../features/deleteItemsSlice"
import { Button } from "react-bootstrap"
import { XCircle } from "react-bootstrap-icons"

export const DeleteItemButton = ({ item }: { item: IOrderItems }) => {
    const dispatch = useDispatch()
    const deleteItem = (item: IOrderItems) => {
        const items = [item]
        dispatch(setDeleteItemsStore(items))
    }
    return (
        <div style={{ alignContent: 'center', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button variant="custom" onClick={() => { deleteItem(item) }} className="d-flex p-1 rounded btn-outline-delete" style={{ alignItems: 'center' }}><XCircle /></Button>
        </div>
    )
}
